import type {
    AttributeDeviceValueEditPayload,
    AttributeDeviceValuePayload,
    AttributeDeviceValueResponse,
} from '@/types/apps/attribute-device-value.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

export interface AttributeDeviceValueServiceInterface {}

type AttributeDeviceValueListResponse = ApiResponse<
    PaginatedResult<AttributeDeviceValueResponse>
>;
type AttributeDeviceValueDetailResponse =
    ApiResponse<AttributeDeviceValueResponse>;

export class AttributeDeviceValueService
    implements Indexable, Showable, Creatable, Updatable, Deletable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    public endpoints = {
        base: () => '/api/attribute-device-value',
        detail: (id: string) => `/api/attribute-device-value/${id}`,
    };

    public index(
        params?: QueryParams
    ): Promise<AttributeDeviceValueListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<AttributeDeviceValueDetailResponse> {
        return this.apiClient.fetchApi<AttributeDeviceValueResponse>(
            this.endpoints.detail(id),
            params
        );
    }

    public create(
        payload: AttributeDeviceValuePayload
    ): Promise<ApiResponse<AttributeDeviceValueResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }

    public update(
        id: string,
        payload: AttributeDeviceValueEditPayload
    ): Promise<ApiResponse<AttributeDeviceValueResponse>> {
        return this.apiClient.putApi(this.endpoints.detail(id), payload);
    }

    public destroy(ids: string[], isHardDeleted?: boolean): Promise<any> {
        return this.apiClient.destroyApi<void>(
            this.endpoints.base(),
            ids,
            isHardDeleted
        );
    }
}
